<template>
  <footer>
    <div class="footer-wrap">
      <div class="footer-blocks">
        <div class="logo-domus-ed">
          <a href="http://www.edidomus.it" rel="noFollow" class="editor">
            <img
              src="https://www.quattroruote.it/auto-usate/img/usato/ed.svg"
              srcset=""
              width="185"
              height="85"
              sizes=""
              alt=""
              title=""
              loading="lazy"
              class="lazy-image"
            />
          </a>
        </div>
        <div class="footer-text-center footer-logo-container">
          <div class="footer-logo">
            <img
              src="https://www.quattroruote.it/auto-usate/img/usato/logo.svg"
              height="18"
              alt="Quattroruote"
              title="Quattroruote"
            />
            <div class="footer-contacts-links ">
              <a title="Contatti" href="https://www.quattroruote.it/contatti.html" class="">
                <u>Contatti</u>
              </a>
              <a title="Redazione" href="https://www.quattroruote.it/redazione/index.html" class="">
                <u>Redazione</u>
              </a>
              <div class="w-100">
                <a
                  title="Termini e Condizioni d'Uso"
                  href="https://www.quattroruote.it/system/termini-e-condizioni-duso.html"
                  class=""
                >
                  <u>Termini e Condizioni d'Uso</u>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="icons">
          <a
            href="http://www.youtube.com/quattroruotetv"
            target="_blank"
            title="Quattroruote YouTube"
            class="c-tinysocial__youtube"
          >
            <span class="icon-Icona_Social_YouTube"></span>
          </a>
          <a
            href="http://www.facebook.com/Quattroruote"
            target="_blank"
            title="Quattroruote Facebook"
            class="c-tinysocial__facebook"
          >
            <span class="icon-Icona_Social_FB"></span>
          </a>
          <a
            href="http://twitter.com/quattroruote"
            target="_blank"
            title="Quattroruote Twitter"
            class="c-tinysocial__twitter"
          >
            <span class="icon-Icona_Social_Twitter"></span>
          </a>
          <a
            href="https://instagram.com/quattroruote/"
            target="_blank"
            title="Quattroruote Instagram"
            class="c-tinysocial__instagram"
          >
            <span class="icon-Icona_Social_Instagram_Outline"></span>
          </a>
          <a href="#" target="_blank" title="Quattroruote RSS" class="c-tinysocial__rss">
            <span class="icon-Icona_Wifi"></span>
          </a>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="row-mt-3">
        <div class="col-12">
          <div class="links">
            <ul class="list-unstyled d-flex justify-content-center flex-wrap mb-0">
              <li class="mb-2" v-for="footerLink in footerData.footerlink" :key="footerLink.code">
                <a
                  :href="footerLink.url"
                  :rel="footerLink.rel ? footerLink.rel : ''"
                  target="_blank"
                  >{{ footerLink.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="">
        <div
          class="copy"
          v-html="
            footerData.footertesti && footerData.footertesti.text ? footerData.footertesti.text : ''
          "
        ></div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Footer',
  data() {
    return {
      footerData: [],
    };
  },
  async mounted() {
    let response = await axios.get('/api/footer-links');
    this.footerData = response.data;
    console.log(this.footerData);
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/Footer.vue